<template>
  <el-dialog
    title="联系我们"
    :visible.sync="show"
    width="40%"
    center
  >
    <div class="connect">
      <p><img src="@/assets/images/circle_phone.gif">联系电话：{{phone}}</p>
      <p><img src="@/assets/images/circle_email.gif">公司邮箱：company.service@foxlean.com</p>
      <p><img src="@/assets/images/circle_support.gif">技术支持：<img
          src="@/assets/images/support_.jpg"
          style="width:100px;position:absolute;"
        ></p>
    </div>

  </el-dialog>
</template>
<script>
import constant from "@/assets/constant";
export default {
  name: "connect",

  data() {
    return {
      show: false,
      phone: constant.phoneNo,
    };
  },
  methods: {
    showdialogPhone() {
      this.show = true;
    },
  },
};
</script>
<style lang="stylus" scoped>
.connect {
  font-size: 20px;

  img {
    margin-left: 35px;
    margin-right: 35px;
    width: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/fixed/connect.vue